import { render, staticRenderFns } from "./woodList.vue?vue&type=template&id=72f2cbb0&scoped=true&"
import script from "./woodList.vue?vue&type=script&lang=js&"
export * from "./woodList.vue?vue&type=script&lang=js&"
import style0 from "./woodList.vue?vue&type=style&index=0&id=72f2cbb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f2cbb0",
  null
  
)

export default component.exports